import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import { getFaviconUrl, getFaviconUrlFallback, getWebsiteName } from 'src/utils/faviconUtils';
import PropTypes from 'prop-types';

const WebsiteAvatar = ({ url, outlet, sx = {}, size = 32, fallbackText = 'EXT', ...props }) => {
  const [faviconUrl, setFaviconUrl] = useState('');
  const [faviconError, setFaviconError] = useState(false);
  const [fallbackError, setFallbackError] = useState(false);

  useEffect(() => {
    if (url) {
      const favicon = getFaviconUrl(url, size);
      setFaviconUrl(favicon);
      setFaviconError(false);
      setFallbackError(false);
    } else {
      setFaviconUrl('');
      setFaviconError(true);
      setFallbackError(true);
    }
  }, [url, size]);

  const handleFaviconError = () => {
    if (!faviconError) {
      // Try fallback service
      setFaviconError(true);
      const fallbackUrl = getFaviconUrlFallback(url);
      if (fallbackUrl) {
        setFaviconUrl(fallbackUrl);
      } else {
        setFallbackError(true);
      }
    } else {
      // Both services failed
      setFallbackError(true);
    }
  };

  // Determine what to display
  const shouldShowFavicon = faviconUrl && !faviconError && !fallbackError;
  const displayText = outlet ? getWebsiteName(outlet) : url ? getWebsiteName(url) : fallbackText;

  const defaultSx = {
    width: size,
    height: size,
    overflow: 'hidden',
    fontSize: '1rem',
    fontWeight: 'bold',
    backgroundColor: shouldShowFavicon ? 'white' : 'grey.300',
    color: shouldShowFavicon ? 'transparent' : 'grey.700',
    border: shouldShowFavicon ? '1px solid #e0e0e0' : 'none',
    '& img': {
      objectFit: 'contain',
    },
    ...sx,
  };

  return (
    <Avatar src={shouldShowFavicon ? faviconUrl : undefined} onError={handleFaviconError} sx={defaultSx} {...props}>
      {!shouldShowFavicon && displayText}
    </Avatar>
  );
};

export default WebsiteAvatar;
WebsiteAvatar.propTypes = {
  url: PropTypes.string,
  outlet: PropTypes.string,
  sx: PropTypes.object,
  size: PropTypes.number,
  fallbackText: PropTypes.string,
};
